import { FC } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../Button";
import styles from "./styles.module.scss";

interface Props {
    title: string;
    description: string;
    ctaLabel?: string;
    ctaRoute?: string;
}

const GraduationNextStep: FC<Props> = ({
    title,
    description,
    ctaLabel,
    ctaRoute,
}) => {
    const navigate = useNavigate();

    return (
        <div className={styles.card}>
            <h3 className={styles.cardTitle}>Prochaine étape</h3>
            <div className={styles.nextStepBlock}>
                <p className={styles.nextStepTitle}>{title}</p>
                <p className={styles.nextStepDescription}>{description}</p>
                {ctaLabel && ctaRoute && (
                    <Button
                        size="newSmall"
                        variant="primary"
                        label={ctaLabel}
                        className={styles.nextStepCtaButton}
                        onClick={() => {
                            if (/^https?:\/\//i.test(ctaRoute)) {
                                window.location.href = ctaRoute;
                                return;
                            }
                            navigate(ctaRoute);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default GraduationNextStep;
